import { useState } from "react";
import { Input } from "../../forms/Input";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../../forms/Select";
import { ArrowUpDown } from "lucide-react";
import { ArmyLogo, ETHLogo } from "./Icons";

export const PoolSimulatorTool = () => {
  const [usdAmount, setUsdAmount] = useState(null);
  const [tokenAmount, setTokenAmount] = useState(null);
  const [tokenTaxAmount, setTokenTaxAmount] = useState(null);
  const [poolMeta, setPoolMeta] = useState(null);
  const [sellingToken, setSellingToken] = useState(false);
  const [sellAmmount, setSellammount] = useState(null);
  const [buyAmmount, setBuyAmmount] = useState(null);

  const sellHandler = (val) => {
    setSellammount(val);
    if (buyAmmount !== null) {
      setBuyAmmount(null);
    }
  };
  const buyHandler = (val) => {
    setBuyAmmount(val);
    if (buyAmmount !== null) {
      setSellammount(null);
    }
  };
  return (
    <>
      <div className="grid grid-cols-4 gap-x-2">
        <div className="flex flex-col col-span-1 rounded-2xl border border-neutral-300/20  px-2 py-5 h-full">
          <div className="flex flex-col gap-y-2">
            <div className="text-sm font-bold mb-2 text-center">Pool stats</div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Amount USDT
              </div>
              <Input
                type="number"
                placeholder="Enter USDT amount"
                className="rounded-full font-bold border-neutral-300/20"
                value={usdAmount}
                onChange={(e) => setUsdAmount(e.target.value)}
              />
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Amount TOKEN
              </div>
              <Input
                type="number"
                placeholder="Enter TOKEN amount"
                className="rounded-full font-bold border-neutral-300/20"
                value={tokenAmount}
                onChange={(e) => setTokenAmount(e.target.value)}
              />
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Token Tax
              </div>
              <Input
                type="number"
                placeholder="Enter Token Tax"
                className="rounded-full font-bold border-neutral-300/20"
                value={tokenTaxAmount}
                onChange={(e) => setTokenTaxAmount(e.target.value)}
              />
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Pool meta
              </div>
              <Select
                onValueChange={setPoolMeta}
                className="rounded-full font-bold border-neutral-300/20"
              >
                <SelectTrigger className="w-[180px] rounded-full font-bold border-neutral-300/20">
                  <SelectValue placeholder="Select Pool meta" />
                </SelectTrigger>
                <SelectContent className=" font-bold border-neutral-300/20 !bg-neutral-900 z-10">
                  <SelectGroup className=" font-bold border-neutral-300/20 bg-nutral-900">
                    <SelectLabel>Pool meta's</SelectLabel>
                    <SelectItem value="o-1">Option 1</SelectItem>
                    <SelectItem value="o-2">Option 2</SelectItem>
                    <SelectItem value="o-3">Option 3</SelectItem>
                    <SelectItem value="o-4">Option 4</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
        <div className="col-span-2 ">
          <div className="w-full flex flex-col gap-y-1 relative">
            <button
              onClick={() => setSellingToken(!sellingToken)}
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-neutral-700 hover:bg-neutral-600 rounded-md border-4 border-neutral-900 p-2"
            >
              <ArrowUpDown size={25} />
            </button>
            <div className="rounded-2xl border border-neutral-300/20 w-full py-5 px-2 flex flex-col gap-y-4">
              <div className="text-sm font-bold">Sell</div>
              <div className="flex flex-row justify-between">
                <Input
                  type="number"
                  placeholder="0"
                  className="max-w-[200px] !text-xl rounded-full  font-bold border-neutral-300/20"
                  value={sellAmmount}
                  onChange={(e) => sellHandler(e.target.value)}
                />
                <div>{sellingToken ? <ArmyLogo /> : <ETHLogo />}</div>
              </div>
              <div>
                <div className="text-sm font-bold text-neutral-500">0 USD</div>
              </div>
            </div>
            <div className="rounded-2xl bg-neutral-300/20 w-full py-5  px-2 flex flex-col gap-y-4">
              {" "}
              <div className="text-sm font-bold">Buy</div>
              <div className="flex flex-row justify-between">
                <Input
                  type="number"
                  placeholder="0"
                  className="max-w-[200px] rounded-full !text-xl font-bold border-neutral-900/80"
                  value={buyAmmount}
                  onChange={(e) => buyHandler(e.target.value)}
                />
                <div>{!sellingToken ? <ArmyLogo /> : <ETHLogo />}</div>
              </div>
              <div>
                <div className="text-sm font-bold text-neutral-500">0 USD</div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col col-span-1 rounded-2xl border border-neutral-300/20  px-2 py-5 h-full">
          <div className="flex flex-col gap-y-1">
            <div className="text-sm font-bold mb-2 text-center">Output</div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                USDT in pool:
              </div>
              <div>123123$</div>
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Token in pool:
              </div>
              <div>123123</div>
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Strating price:
              </div>
              <div>123123</div>
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Ending price:
              </div>
              <div>123123</div>
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Price change:
              </div>
              <div>123123</div>
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Fees:
              </div>
              <div>123123</div>
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Taxes:
              </div>
              <div>123123</div>
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                Token received:
              </div>
              <div>123123</div>
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <div className="text-xs text-neutral-300 whitespace-nowrap">
                USDT received:
              </div>
              <div>123123</div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-x-2">
        <div className="col-span-1"></div>
        <div className="col-span-2">
          <button className="w-full rounded-2xl p-2 mt-2  bg-neutral-300/20 text-center uppercase text-base font-semibold text-neutral-200 oswald hover:bg-neutral-400/20">
            {buyAmmount || sellAmmount ? "Swap" : "Insert an amount"}
          </button>
        </div>

        <div className="col-span-1"></div>
      </div>
    </>
  );
};
